// TerminalComponent.tsx
import React, { useEffect, useRef } from "react";
import { Terminal } from "@xterm/xterm";
import "@xterm/xterm/css/xterm.css";
import { FitAddon } from "@xterm/addon-fit";
import { useSocket } from "../../../Socket";

const OpenTerminal = () => {
  const terminalRef = useRef(null);
  const term = useRef(null);
  const fitAddon = useRef(null);
  let currentCommand = "";
  const { socket } = useSocket();

  useEffect(() => {
    if (terminalRef.current && !term.current) {
      term.current = new Terminal({
        cursorBlink: true,
      });
      fitAddon.current = new FitAddon();

      term.current.open(terminalRef.current); //to open the terminal

      const disposeResize = term.current.onResize(({ cols, rows }) => {
        console.log(`Terminal resized to ${cols}x${rows}`);
      });

      term.current.loadAddon(fitAddon.current);
      term.current.open(terminalRef.current);
      // Initial fit to container
      // fitAddon.current.fit();

      const handleResize = () => {
        fitAddon.current?.fit();
      };

      window.addEventListener("resize", handleResize);

      // Prompt function
      const prompt = () => {
        currentCommand = "";
        // term.current?.write("");
        term.current?.write("\r");
      };

      prompt();

      term.current.onData((data) => {
        if (data.charCodeAt(0) === 13) {
          socket.emit("COMMAND_INPUT", { input: currentCommand });
          currentCommand = "";
          term.current?.write("\r\n");
          // prompt();
        } else if (data.charCodeAt(0) === 8 || data.charCodeAt(0) === 127) {
          currentCommand = currentCommand.slice(0, -1);
          term.current?.write("\b \b");
        } else {
          currentCommand += data;
          term.current?.write(data);
        }
      });

      return () => {
        window.removeEventListener('resize', handleResize);
        disposeResize.dispose();
        term.current?.dispose();
      };
    }

  }, []);
  useEffect(() => {
    socket.on("ssm-data", (response) => {
      term.current?.write(`${response}`);
    });

    return () => {
      socket.off("ssm-data"); // cleanup on unmount
    };
  }, []);

  return (
    <>
      <div ref={terminalRef} className="mt-10" />
    </>
  );
};

export default OpenTerminal;
